<!-- eslint-disable vuejs-accessibility/label-has-for -->
<template>
  <div class="filters__wrapper" v-if="filterList && filterList.length">
    <div class="filter-desktop-wrapper">
      <button
        class="clear-btn text-button --desktop"
        @click="clearFilters"
        v-if="
          this.selectedFiltersArray && this.selectedFiltersArray.length != 0
        "
      >
        {{ clearBtn }}
      </button>
      <div
        role="group"
        :aria-labelledby="filter.title"
        v-for="(filter, index) in filterList"
        :key="filter.title"
      >
        <details
          class="accordion sub-accordion"
          v-if="filter.facetlist && filter.facetlist.length"
        >
          <summary
            class="accordion__summary"
            aria-expanded="false"
            :id="[filter.title]"
          >
            <span>{{ filter.title }}</span>
           
          </summary>
          <div class="details__contents">
            <ul class="tags__wrapper" data-tag-wrapper id="tags__wrapper" >
              <li
                v-for="(facet, i) in filter.facetlist"
                :key="facet.name"
                class="tags__item"                
                >
                <input
                  type="checkbox"
                  :id="'desktop-' + index + '-' + i"
                  :name="facet.name"
                  :value="facet.name"
                  :data-selected="facet.selected"
                  v-model="facet.selected"
                  tabindex="0"
                  @keydown.enter.prevent="handleCheckboxEnter(facet, filter)"
                  @change="filterClick(facet.name, filter.query, facet.selected, facet.tagging)"
                />
                <label  
                  :for="'desktop-' + index + '-' + i"
                  v-bind:class="facet.selected ? 'selected' : ''"
                >
                  <span class="tags__tag"> {{ facet.name }}</span>
                </label>
              </li>
            </ul>
          </div>
        </details>
      </div>
    </div>
    <div class="filter-mobile-wrapper">
      <the-modal v-slot="scope" modalid="filter">
        <div class="filter-container">
          <h2 role="heading">{{filterHeading}}</h2>
          <div
            role="group"
            :aria-labelledby="filter.title"
            v-for="(filter, index) in filterList"
            :key="filter.title"
          >
            <details
              class="accordion"
              v-if="filter.facetlist && filter.facetlist.length"
            >
              <summary
                class="accordion__summary"
                aria-expanded="false"
                :id="[filter.title]"
              >
                <span>{{ filter.title }}</span>
               
              </summary>
              <div class="details__contents">
                <ul class="tags__wrapper" data-tag-wrapper id="tags__wrapper">
                  <li
                    v-for="(facet, i) in filter.facetlist"
                    :key="facet.name"
                    class="tags__item"
                  >
                    <input
                      tabindex="0"
                      type="checkbox"
                      :id="'mobile-' + index + '-' + i"
                      :name="facet.name"
                      :value="facet.name"
                      :data-selected="facet.selected"
                      v-model="facet.selected"
                      @change="
                        filterClick(facet.name, filter.query, facet.selected, facet.tagging)
                      "
                        @keydown.enter.prevent="
                        handleCheckboxEnter(facet, filter)
                      "
                    />
                    <label
                      :for="'mobile-' + index + '-' + i"
                      v-bind:class="facet.selected ? 'selected' : ''"
                    >
                      <span class="tags__tag"> {{ facet.name }}</span>
                    </label>
                  </li>
                </ul>
              </div>
            </details>
          </div>
        </div>
        <div class="mob-btn">
          <button
            class="button -primary"
            @click="scope.toggle"
            :disabled="!facetSelected"
          >
          {{ showResults }}
            
          </button>
          <button
            class="clear-btn text-button --desktop"
            @click="clearFilters"
            :disabled="!facetSelected"
          >
          {{ clearBtn }}
          </button>
        </div>
      </the-modal>
    </div>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
import { pushEvent } from '../../../scripts/utils/datalayer';

export default {
  props: {
    filters: {
      type: String,
      required: true,
    },
    clearBtn: {
      type: String,
      default: 'Clear all'
    },
    showResults: {
      type: String,
      default: 'Show results'
    },
    filterHeading: {
      type: String,
      default: 'Filter Products'
    },
  },
  data() {
    return {
      selectedFilters: [],
      filterList: [],
      busName: 'item-grid',
      loading: false,
      windowWidth: window.innerWidth,
      selectedFiltersArray: [],
      filterListValues: [],
      urlString: '',
      headerList: [],
      pageInfoUrl: '',
      api: '',
      facetSelected: false,
    };
  },
  created() {
    this.updateFilterDisplay(JSON.parse(this.filters));
  },
  mounted() {
    eventBus.$on(`${this.busName}:clearFilters`, this.clearFilters);
    eventBus.$on(`${this.busName}:update-filters`, this.updateFilterDisplay);
    this.getSelectedFilter();
  },
  beforeDestroy() {
    eventBus.$off(`${this.busName}:clearFilters`, this.clearFilters);
    eventBus.$off(`${this.busName}:update-filters`, this.updateFilterDisplay);
    eventBus.$off(`${this.busName}:filters`, this.syncSelectedFilters);
    eventBus.$off(`${this.busName}:loadingState`);
  },
  methods: {
    syncSelectedFilters(currentFilterSelections) {
      //selectedFilters was used in v-model of checkbox, remove it if not required in future
      this.selectedFilters = currentFilterSelections;
    },
    handleCheckboxEnter(facet, filter) {
      facet.selected = !facet.selected;
      this.filterClick(facet.name, filter.query, facet.selected, facet.tagging);
    },
    clearFilters() {
      this.selectedFilters = [];
      this.selectedFiltersArray = [];
      this.facetSelected = false; //for mobile clear all
      eventBus.$emit(`${this.busName}:filters`, this.selectedFiltersArray);
    },
    updateFilterDisplay(filterData) {
      this.filterList = filterData;
    },
    //getSelectedFilter from Backend response using selected attribute
    getSelectedFilter() {
      for (const item of this.filterList) {
        for (const filterTag of item.facetlist) {
          if (filterTag.selected) {
            this.selectedFiltersArray.push({
              query: item.query,
              filterTag: filterTag.name,
            });
            this.facetSelected = true;
          }
        }
      }
    },

    filterClick(name, query, facetSelected, filterTagging) {
      //disable UI to prevent click
      document.body.style.pointerEvents = 'none';

      const index = this.selectedFiltersArray.findIndex(
        (el) => el.filterTag === name
      );
      if (facetSelected) {
        // On checkbox check, push item into selectedFiltersArray if not present
        if (index === -1) {
          this.selectedFiltersArray.push({ filterTag: name, query: query });
        }
        if(filterTagging !== null && filterTagging !== undefined) {
          pushEvent(filterTagging);
        }
      } else {
        // On checkbox uncheck, remove item from selectedFiltersArray if present
        if (index !== -1) {
          this.selectedFiltersArray.splice(index, 1);
        }
      }
      if (this.selectedFiltersArray && this.selectedFiltersArray.length > 0) {
        this.facetSelected = true;
      } else {
        this.facetSelected = false;
      }
      eventBus.$emit(`${this.busName}:filters`, this.selectedFiltersArray);
    },
  },
};
</script>
<style lang="scss" src="./product-filters.scss"></style>
